import FreedomLogoLight from 'assets/icons/landing/logo-light.svg?component'
import DamuLogoDark from 'assets/images/landing/damu-logo-dark.svg?component'
import DamuLogoLight from 'assets/images/landing/damu-logo-light.svg?component'
import FreedomLogoDark from 'assets/images/landing/logo-dark.svg?component'
import Container from 'components/UI/Landing/container'
import SectionTitle from 'components/UI/Landing/section-title'
import { ThemeContext, ThemeProviderContext } from 'contexts/theme-context'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import TermCards from './term-cards'

export type Funds = 'damu' | 'freedom'

export default function TermsSection() {
  // Tools
  const { t } = useTranslation('landing')

  const themeContext = useContext(ThemeContext)
  const { theme } = themeContext as ThemeProviderContext
  const isDark = theme === 'dark'

  const [activeFund, setActiveFund] = useState<Funds>('freedom')

  const handleFundChange = (fund: Funds) => {
    setActiveFund(fund)
  }

  return (
    <section className='lg:pt-16 pb-[100px]'>
      <Container>
        <div className='flex flex-wrap items-center gap-y-4 justify-between'>
          <SectionTitle title={t('loan-terms.title')} className='z-10' />
          <div
            className={`z-10 p-2 rounded-[20px] flex items-center w-full sm:w-auto mt-[19px]  shadow-md sm:mt-0 bg-white dark:bg-secondary`}
          >
            <button
              type='button'
              className={`w-full sm:w-[169px] py-2 px-7 sm:px-4 rounded-[16px] flex justify-center items-center`}
              style={{
                background: activeFund === 'freedom' ? 'linear-gradient(239.72deg, #38DC71 0%, #00812C 102.7%)' : ''
              }}
              onClick={() => setActiveFund('freedom')}
            >
              {activeFund === 'freedom' || isDark ? <FreedomLogoLight /> : <FreedomLogoDark />}
            </button>
            <button
              type='button'
              className={`w-full sm:w-[173px] py-2 px-7 sm:px-4 rounded-[16px] flex justify-center items-center`}
              style={{
                background: activeFund === 'damu' ? 'linear-gradient(239.72deg, #38DC71 0%, #00812C 102.7%)' : ''
              }}
              onClick={() => setActiveFund('damu')}
            >
              {activeFund === 'damu' || isDark ? <DamuLogoDark width={'109px'} /> : <DamuLogoLight width={'109px'} />}
            </button>
          </div>
        </div>
        <TermCards fund={activeFund} onFundChange={handleFundChange} />
      </Container>
    </section>
  )
}
